// http://davidwalsh.name/function-debounce
export default function debouncer(fn, wait) {
	var timeout;
	return function () {
		var _this = this;
		var args = arguments;
		var later = function () {
			timeout = null;
			fn.apply(_this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(later, wait || 100);
	};
}
